import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { routeFileSelector } from '@/utilz';
import WithFilter from '@/views/screens/common/WithFilter';

import SaversShipmentContent from './shipment/SaversShipmentContent';
import SaversShipmentFilters from './shipment/SaversShipmentFilters';
import SaversShipmentFooter from './shipment/SaversShipmentFooter';
import SaversTopShipmentFilter from './shipment/SaversTopShipmentFilters';

const SaversShipment = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <WithFilter
      headerContent={<SaversTopShipmentFilter />}
      filterElement={<SaversShipmentFilters />}
      contentElement={<SaversShipmentContent />}
      filterTitle={t('translation:default.fields.filter')}
      pageTitle={t('translation:shipment.header.title')}
      footerContent={<SaversShipmentFooter />}
    />
  );
};

export default memo(SaversShipment);
